var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"main-wrapper"}},[_c('HeaderReseller'),_c('AsideReseller'),(_vm.getHeader)?_c('div',{staticClass:"page-wrapper",class:{ sinmenu: _vm.sinmenu },on:{"click":_vm.ShowHiddenAside}},[_c('router-view')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }